import { render, staticRenderFns } from "./TaxReturnCreditablePeriod.vue?vue&type=template&id=2d079fa9&scoped=true"
import script from "./TaxReturnCreditablePeriod.vue?vue&type=script&lang=js"
export * from "./TaxReturnCreditablePeriod.vue?vue&type=script&lang=js"
import style0 from "./TaxReturnCreditablePeriod.vue?vue&type=style&index=0&id=2d079fa9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d079fa9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d079fa9')) {
      api.createRecord('2d079fa9', component.options)
    } else {
      api.reload('2d079fa9', component.options)
    }
    module.hot.accept("./TaxReturnCreditablePeriod.vue?vue&type=template&id=2d079fa9&scoped=true", function () {
      api.rerender('2d079fa9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/components/TaxReturnCreditablePeriod.vue"
export default component.exports